import { getPermissions } from "@/helper/collection";

export const RoleManagementRoutes = {
    path: "role-management",
    name: "Role Management",
    redirect: "role-management/role-management-master",
    component: {
        render(c) {
            return c("router-view");
        }
    },
    children: [{
        path: 'role-management-master',
        name: 'Role Management Master',
        component: () => import('@/components/Pages/RoleManagementContainer/roleManagementMaster.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '')
        }
    },
    {
        path: 'module-features',
        name: 'Module Features',
        component: () => import('@/components/Pages/RoleManagementContainer/moduleFeatures.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '',150,1)
        }
    },
    {
        path: 'add-module-features',
        name: 'Add Module Features',
        component: () => import('@/components/Pages/AddContainer/addModuleFeatures'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '',150,2)
        }
    },
    {
        path: 'edit-module-features',
        name: 'Edit Module Features',
        component: () => import('@/components/Pages/EditContainer/editModuleFeatures'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'HoManager', 'RoleRoleManagement'], false, '',150,2)
        }
    },
    {
        path: 'view-module-features',
        name: 'View Module Features',
        component: () => import('@/components/Pages/DetailsContainer/viewModuleFeatures'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '',150,1)
        }
    },
    {
        path: 'role-access',
        name: 'Role Access',
        component: () => import('@/components/Pages/RoleManagementContainer/RoleAccessComponents/roleAccess.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '',151,1)
        }
    },
    {
        path: 'add-role-access',
        name: 'Add Role Access',
        component: () => import('@/components/Pages/RoleManagementContainer/RoleAccessComponents/addRoleAccess.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '',151,2)
        }
    },
    {
        path: 'view-role-access',
        name: 'View Role Access',
        component: () => import('@/components/Pages/RoleManagementContainer/RoleAccessComponents/viewRoleAccess.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '',151,1)
        }
    },
    {
        path: 'edit-role-access',
        name: 'Edit Role Access',
        component: () => import('@/components/Pages/RoleManagementContainer/RoleAccessComponents/editRoleAccess.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '',151,2)
        }
    },
    ]
}


// WEBPACK FOOTER //
// ./src/router/rolemanagementRoutes.js